<template>
    <div></div>
</template>

<script>
    export default {
        props: ['topic', 'route'],
        data: function () {
            return {}
        },
        mounted: function () {
            axios.post(this.route, {})
                .then((res)=> {
                    window.AppEventBus.$emit('topicRead', res.data.unreadMessagesCount, res.data.infoMessage, res.data.topicId);
                });
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/admin-panel/components/admin/messenger/makeMessagesAsRead.vue